export default "__VITE_ASSET__D_Z9bvvR__"